import { Search, MoreHorizontal } from 'lucide-react';

import { DashboardLayout } from '@/components/dashboard/DashboardLayout';
import { PageHeader } from '@/components/dashboard/PageHeader';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { users } from '@/lib/mockData';
import { cn } from '@/lib/utils';

const roleStyles: Record<string, string> = {
  participant: 'bg-muted text-muted-foreground border-border',
  hotesse: 'bg-accent/15 text-accent border-accent/30',
  partenaire: 'bg-primary/15 text-primary border-primary/30',
  admin: 'bg-foreground/10 text-foreground border-foreground/15',
};
const roleLabels: Record<string, string> = {
  participant: 'Participant',
  hotesse: 'Hôtesse',
  partenaire: 'Partenaire',
  admin: 'Admin',
};

const AdminUsers = () => (
  <DashboardLayout
    role="admin"
    user={{ name: 'Équipe Winkô', subtitle: 'Super Admin', initials: 'WK' }}
  >
    <PageHeader
      title="Utilisateurs"
      subtitle="Tous les comptes — participants, hôtesses, partenaires, admins."
    />
    <div className="mb-4 flex flex-wrap items-center gap-3">
      <div className="relative w-full max-w-sm">
        <Search className="pointer-events-none absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
        <Input placeholder="Rechercher un utilisateur…" className="h-10 pl-9" />
      </div>
    </div>
    <div className="overflow-hidden rounded-2xl border border-border bg-card shadow-soft">
      <table className="w-full text-sm">
        <thead className="border-b border-border bg-muted/50">
          <tr className="text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            <th className="px-5 py-3">Nom</th>
            <th className="px-5 py-3">Email</th>
            <th className="px-5 py-3">Rôle</th>
            <th className="px-5 py-3">Ville</th>
            <th className="px-5 py-3">Inscrit</th>
            <th className="px-5 py-3">Statut</th>
            <th className="px-5 py-3" />
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {users.map(u => (
            <tr key={u.id} className="hover:bg-muted/30">
              <td className="px-5 py-3 font-medium">{u.name}</td>
              <td className="px-5 py-3 text-muted-foreground">{u.email}</td>
              <td className="px-5 py-3">
                <span
                  className={cn(
                    'inline-flex rounded-full border px-2.5 py-0.5 text-xs font-semibold',
                    roleStyles[u.role]
                  )}
                >
                  {roleLabels[u.role]}
                </span>
              </td>
              <td className="px-5 py-3 text-muted-foreground">{u.city}</td>
              <td className="px-5 py-3 text-muted-foreground">{u.joined}</td>
              <td className="px-5 py-3">
                <span
                  className={cn(
                    'inline-flex rounded-full border px-2.5 py-0.5 text-xs font-semibold',
                    u.status === 'active'
                      ? 'border-emerald-500/30 bg-emerald-500/10 text-emerald-700'
                      : 'border-border bg-muted text-muted-foreground'
                  )}
                >
                  {u.status === 'active' ? 'Actif' : 'Suspendu'}
                </span>
              </td>
              <td className="px-5 py-3 text-right">
                <Button variant="ghost" size="icon">
                  <MoreHorizontal className="size-4" />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </DashboardLayout>
);

export default AdminUsers;
